import { useState, useEffect } from "react";

import { reportError } from "../../../functions/sentry";
import apiCall from "../../utilities/auth/apiCall";
import { assessmentNextContent } from "../../utilities/auth/authApi";
import sendAssessmentResponses from "../../../functions/sendAssessmentResponses";
import alertMessage from "../../utilities/alertMessage";

import AssessmentInstruction from "../helpers/assessmentInstruction";
import ReadPassage from "./readPassage";
import Modal from "../../utilities/modal";
import SaveModalBody from "../helpers/saveModalBody";


function AssessmentRead(props) {

  // Define variables
  const [modal, setModal] = useState(null);
  const [step, setStep] = useState(0);
  const [passages, setPassages] = useState([]);
  const [passageStep, setPassageStep] = useState(0);
  const [responses, setResponses] = useState([]);
  const handleSteps = props.handleSteps;
  const instructions = props.instructions;
  const config = props.config;
  const readPassageCount = config.readPassageCount;
  const passageInitial = config.passages;
  const retryPossible = config.retryCount;
  const typeWord = 'Passage';


  // Component load actions
  useEffect(() => {
    setPassages(passageInitial);
  }, []);


  // Define functions
  function handleNextAction(responseData) {

    // Save the repsonse data
    const updatedResponses = [...responses, responseData];
    setResponses(updatedResponses);


    // Handle the last passage
    if( readPassageCount === (passageStep + 1) ) {
      saveData(updatedResponses);
    } else {

      // Get the next content
      const payload = {
        code: config.code,
        type: 'passage',
        score: responseData.overall.percent,
        previousIds: passages.map((p) => p.id)
      }

      apiCall(assessmentNextContent, payload).then((response) => {
        if( response.success ) {

          // Add the new passage to the passages array
          const updatedPassages = [...passages, response.data.content];
          setPassages(updatedPassages);

          // Move to the next passage
          setPassageStep(passageStep + 1);
          logProgress({passageStep: passageStep + 2});

        } else {
          reportError(response.error);
          alertMessage(response.error, 'error');
        }

      });
    }
  }

  function saveData(updatedResponses) {
    setModal(<Modal body={<SaveModalBody />} />);

    const payload = {
      type: 'reading',
      code: config.code,
      responses: updatedResponses
    }

    sendAssessmentResponses(payload).then((response) => {
      if( response.success ) {
        setTimeout(() => {
          logProgress({section: 3, step: 0});
        }, 1000);
      } else {
        reportError(response.error);

        setModal(null);
        alertMessage(response.error, 'error');
      }
    });
  }

  function logProgress(data) {
    if( data.step ) {
      setStep(data.step);
    }

    handleSteps(data);
  }


  // Screen components
  let bodyContent;
  let passageCountElement = <div class='assess-passage-number-container'>&nbsp;</div>;

  if( step === 0 ) {
    bodyContent = <AssessmentInstruction logProgress={logProgress} instructions={instructions} nextStep={1} passageStep={1} />;
  } else if( step === 1 ) {

    passageCountElement = <div class='assess-passage-number-container'>{typeWord} {passageStep+1} of {readPassageCount}</div>;

    bodyContent = (
      <ReadPassage
        passage={passages[passageStep]}
        nextAction={handleNextAction}
        instructionRecord={instructions.record}
        instructionReview={instructions.review}
        timerSpeak={config.readSpeakTimer}
        timerReview={config.readReviewTimer}
        retryPossible={retryPossible}
        cefrLevel={config.readStartLevel}
        scoreType={'read'}
      />
    );
  }


  return (
    <>
      <h1>Read Aloud</h1>
      {passageCountElement}
      {bodyContent}
      {modal}
    </>
  );
}

export default AssessmentRead;